import Isotope from "isotope-layout";

export const property = ['$http', 'modalFactory', '$sce', 'compareTool', '$timeout', '$filter', function($http, $modal, $sce, $compare, $timeout, $filter) {
    return {
        link: function(scope, elem, attrs) {
            let property_id = attrs.property;
            scope.property_id = attrs.property;
            scope.lease_src = $sce.trustAsResourceUrl('/lease-now/?propid=' + scope.property_id);
            // scope.lease_src = $sce.trustAsHtml('<script type="text/javascript" language="javascript" src="https://property.onesite.realpage.com/oll/eol/widget?siteId=' + scope.property_id + '&container=ollWidget"></script>');
            scope.window_location = window.location.href;
            scope.compare = $compare;

            scope.animateFlag = function() {
                var flag = document.querySelector('.tp-SingleProperty_Flag');
                // if (flag) {
                    angular.element(flag).addClass('animate');
                // }
            }

            scope.openCompareModal = function() {
                scope.compare.getFavoritedFloorplans()
                $modal.create(scope, angular.element(document.body), '/wp-content/themes/richman/components/modal/compareFloorplansModal.html');
            }
            scope.openFavouritesModal = function() {
                scope.compare.getFavoritedProperties()
                $modal.create(scope, angular.element(document.body), '/wp-content/themes/richman/components/modal/favouritesModal.html');
            }

            scope.showFloorPlannerModal = function(planner_url) {
                scope.planner_url = $sce.trustAsResourceUrl(planner_url);
                $modal.create(scope, angular.element(document.body), '/wp-content/themes/richman/components/modal/floorPlannerModal.html');
            }
            scope.showMoveInDateModal = function(avail_date, unit_id, lease_url, trackingCode) {
                scope.getLeaseFrame(avail_date, unit_id, '', trackingCode);
                scope.unit_id = unit_id;
                scope.trackingCode = trackingCode;
            }
            scope.showLeaseNowModal = function(lease_url, trackingCode) {
                scope.getLeaseFrame(undefined, undefined, lease_url, trackingCode);
            }
            scope.getLeaseFrame = function(avail_date, unit_id, lease_url, trackingCode) {
                if (avail_date && unit_id) {
                    scope.lease_src = $sce.trustAsResourceUrl('/lease-now/?propid=' + scope.property_id + '&UnitId=' + unit_id + '&MoveInDate=' + avail_date + '&SearchUrl=' + window.location.href);
                    // scope.lease_src = $sce.trustAsHtml('<script type="text/javascript" language="javascript" src="https://property.onesite.realpage.com/oll/eol/widget?UnitId=' + unit_id + '&MoveInDate=' + avail_data + '&siteId=' + scope.property_id + '&container=ollWidget' + '&SearchUrl=' + window.location.href + '"></script>');
                }
                if(typeof trackingCode !== 'undefined'){
                    scope.trackingCodeSantized = $sce.trustAsHtml(trackingCode);
                }
                else{
                    scope.trackingCodeSantized = $sce.trustAsHtml('');
                }

                // var z = document.createElement('div');
                // z.innerHTML = scope.trackingCodeSantized;
                // z.innerHTML = z.innerHTML.replace("write(", "body.insertAdjacentHTML('beforeend',");
                // console.log('z.innerHTML', z.innerHTML);
                // angular.element(document.body).append(z);

                // $sce.URL(frame);
                let mobileScript = document.createElement('script');
                mobileScript.src = `https://property.onesite.realpage.com/!OllToMpp/?s=${scope.property_id}`;
                mobileScript.innerHTML = null;
                document.body.appendChild(mobileScript);
                // angular.element(document).append(`<script language="javascript" src="https://property.onesite.realpage.com/!OllToMpp/?s=${scope.property_id}}"></script>`);
                $modal.create(scope, angular.element(document.body), '/wp-content/themes/richman/components/modal/leaseNowModal.html');
            }

            scope.showAppointmentModal = function(post_id, prop_name, prop_location, show_tour_types, appointment_days, trackingCode, disclaimer_text) {
                // console.log('appointment_days', JSON.parse(appointment_days));
                // console.log('trackingCode ' , trackingCode);
                scope.disclaimer_text = disclaimer_text;
                scope.bookingState = 'ready';
                scope.appointment_modal = true;
                scope.prop_name = prop_name;
                scope.show_tour_types = show_tour_types;
                scope.post_id = post_id;
                let appointment_days_parsed = JSON.parse(appointment_days);
                if (appointment_days_parsed) {
                    scope.appointment_days = appointment_days_parsed.reduce(function(sorted_appointment_days, days) {
                        for (let day in days.week_days) {
                            sorted_appointment_days.push({day: days.week_days[day], times: days.times});
                        }
                        return sorted_appointment_days;
                    }, []);
                } else {
                    scope.appointment_days = [];
                }
                if(typeof trackingCode !== 'undefined'){
                    scope.trackingCodeSantized = $sce.trustAsHtml(trackingCode);
                }
                else{
                    scope.trackingCodeSantized = $sce.trustAsHtml('');
                }
                scope.prop_location = prop_location;
                $modal.create(scope, angular.element(document.body), '/wp-content/themes/richman/components/modal/propertyAppointmentModal.html');

            }
            scope.checkUrlModal = function() {
                scope.urlcheck = scope.urlcheck || false;
                if (!scope.urlcheck) {
                    var locationSearch = window.location.search;
                    if (locationSearch.indexOf('modal=appointment') !== -1 && !scope.appointment_modal) {
                        $timeout(function() {
                            angular.element('.appointment-button').triggerHandler('click');
                        })
                    }
                    scope.urlcheck = true;
                }
            }
            scope.checkUrlModal();

            scope.showContactModal = function(post_id, trackingCode, phone_number) {
                scope.contactState = 'ready';
                scope.post_id = post_id;
                scope.phone_number = phone_number;
                if(typeof trackingCode !== 'undefined'){
                    scope.trackingCodeSantized = $sce.trustAsHtml(trackingCode);
                }
                else{
                    scope.trackingCodeSantized = $sce.trustAsHtml('');
                }
                $modal.create(scope, angular.element(document.body), '/wp-content/themes/richman/components/modal/propertyContactModal.html');
            }

            scope.showMapModal = function(name, address, lat, lng, description) {
                scope.name = name;
                scope.address = address;
                scope.lat = lat;
                scope.lng = lng;
                scope.description = description;
                $modal.create(scope, angular.element(document.body), '/wp-content/themes/richman/components/modal/propertyMapModal.html');
            };

            scope.showFloorplanSmsModal = function(floorplanURL){
                scope.floorplanURL = floorplanURL;
                $modal.create(scope, angular.element(document.body), '/wp-content/themes/richman/components/modal/floorplanSmsModal.html');
            };

            // used for contact and appointment forms
            scope.contactSubmit = function(valid, data){
                if (valid){
                    scope.contactProcess(data);
                    var z = document.createElement('div');
                    z.innerHTML = scope.trackingCodeSantized;
                    z.innerHTML = z.innerHTML.replace("write(", "body.insertAdjacentHTML('beforeend',");
                    angular.element(document.body).append(z);
                } else {
                    scope.showErrors = true;
                }
            };

            // used for contact and appointment forms
            scope.contactProcess = function(data) {
                if (scope.contactState === 'loading') return  
                console.log("submit", scope.contactState);
                data.move_in_date ? data.move_in_date =  $filter('date')(data.move_in_date.getDate(), 'longDate') : '';
                data.appointment_date ? data.appointment_date = $filter('date')(data.appointment_date.getDate(), 'longDate') : ''
                scope.bookingSubmit ? scope.bookingState = 'loading' : scope.contactState = 'loading'
                scope.message = ""
                $http({
                    method: 'POST',
                    url: '/wp-json/richman/v1/contact-form',
                    data: {
                        form: data,
                        post_id: scope.post_id
                    }
                }).then(function successCallback(response) {
                    // console.log('response ' , response);
                    // send data to realpage API
                    if (scope.yardi) {
                        scope.sendToYardi(data);
                    } else {
                        scope.sendToRealPage(data);
                    }
                    
                    if (scope.bookingSubmit) {
                        scope.bookingState = 'success'
                        scope.bookingSubmit = false
                    } else {
                        scope.contactState = 'success'
                    }

                    scope.showErrors = false;
                    scope.contactInputs = {};
                }, function errorCallback(response) {
                    if (scope.bookingSubmit) {
                        scope.bookingState = 'error'
                        scope.bookingSubmit = false
                    } else {
                        scope.contactState = 'error'
                    }

                    // console.log('error response ' , response);
                });
            }

            scope.sendToRealPage = function(data) {
                $http({
                    method: 'POST',
                    url: '/wp-json/richman/v1/realpageapi',
                    data: {
                        url: 'https://onesite.realpage.com/WebServices/CrossFire/prospectmanagement/service.asmx',
                        property_id: scope.property_id,
                        SOAPAction: "http://realpage.com/webservices/InsertProspect",
                        soapBody:   `<InsertProspect xmlns="http://realpage.com/webservices">
                                      <guestCard>
                                        <Prospects>
                                          <Prospect>
                                            <FirstName>${data.first_name}</FirstName>
                                            <LastName>${data.last_name}</LastName>
                                            <Email>${data.email}</Email>
                                            <Numbers>
                                                <Number>${data.phone}</Number>
                                            </Numbers>
                                          </Prospect>
                                        </Prospects>
                                      </guestCard>
                                    </InsertProspect>`,
                    }
                }).then(function successCallback(response) {
                    // console.log('response ' , response);
                }, function errorCallback(response) {
                    // console.log('error response ' , response);
                });
            }

            scope.sendToYardi = function (data) {
                
                console.log(data)
                $http({
                    method: 'POST',
                    url: '/wp-json/richman/v1/yardi-lead',
                    data: {
                        requestType: 'lead',
                        firstName: data.first_name,
                        lastName: data.last_name,
                        email: data.email,
                        phone: data.phone_number,
                        message: data.message ? data.message : `Appointment Date: ${data.appointment_date}, Time: ${data.time ? data.time.time : ''}, Method: ${data.method ? data.method.phone ? 'Phone' : 'Email' : ''}, Move in date: ${data.move_in_date}, Tour Type: ${data.tourtype}, Skype username: ${data.skype_username}, Facetime Contact: ${data.facetime_contact}`,
                        source: 'Signature Website',
                        propertyId: scope.property_id
                        // addr1: data.,
                        // state: data.,
                        // zipCode: data.,

                    }
                })

            }

            scope.filter = {};
            scope.filtered = [];
            scope.FilterFns = {
                bedrooms: function(fp) {
                    if (scope.filter && scope.filter.bedrooms) {
                        return fp.getAttribute('data-bed') == scope.filter.bedrooms
                    } else {
                        return true
                    }
                },
                bathrooms: function(fp) {
                    if (scope.filter && scope.filter.bathrooms) {
                        return fp.getAttribute('data-bath') == scope.filter.bathrooms
                    } else {
                        return true
                    }
                },
                sqft: function(fp) {
                    var sqft = fp.getAttribute('data-sqft')
                    // console.log('sqft', sqft);
                    if (sqft === 0) {
                        return true
                    }
                    return sqft <= scope.sqftSlider.start[1] && sqft >= scope.sqftSlider.start[0]
                },
                rent: function(fp) {
                    var rentLo = fp.getAttribute('data-rent-lo')
                    var rentHi = fp.getAttribute('data-rent-hi')
                    // console.log('rentLo', rentLo);
                    // console.log('rentHi', rentHi);
                    // console.log(scope.rentSlider.start)
                    if (!rentLo && !rentHi) {return true}
                    return rentLo <= scope.rentSlider.start[1] && rentHi >= scope.rentSlider.start[0]
                },
                features: function(fp) {
                    const fp_features = fp.getAttribute('data-features');
                    for (const feature in scope.featureFilter) {
                        if (scope.featureFilter[feature] && fp_features.indexOf(feature) == -1) {
                            return false;
                        }
                    }
                    return true;
                },
                availability: function(fp) {
                    if (scope.filterDate) {
                        const fp_date = new Date(fp.getAttribute('data-avail')).getTime()
                        const filter_date = new Date(scope.filterDate).getTime()
                        // console.log('fp_date ' , fp_date);
                        // console.log('filter_date ' , filter_date);
                        return fp_date <= filter_date
                    } else {
                        return true
                    }
                },
            }

            scope.inFilteredResults = function(fp_id) {
                const inResults = scope.filtered.filter(filtered_fp => fp_id && filtered_fp.id == 'floorplan-'+fp_id);
                return inResults.length;
            }

            if (!scope.sqftMin || !scope.sqftMax) {
                let sqftSlider = document.querySelector('#sqftSlider')
                scope.sqftMin = sqftSlider && sqftSlider.dataset && sqftSlider.dataset.sqftMin ? parseInt(sqftSlider.dataset.sqftMin) : 0
                scope.sqftMax = sqftSlider && sqftSlider.dataset && sqftSlider.dataset.sqftMax ? parseInt(sqftSlider.dataset.sqftMax) : 0
            }   
            scope.sqftSlider = {
                start: [scope.sqftMin, scope.sqftMax],
                step: 10,
                range: {
                    min: scope.sqftMin,
                    max: scope.sqftMax
                },
                connect: true,
                margin: 30,
            }

            if (!scope.rentMin || !scope.rentMax) {
                let rentSlider = document.querySelector('#rentSlider')
                scope.rentMin = rentSlider && rentSlider.dataset ? parseInt(rentSlider.dataset.rentMin) : 0
                scope.rentMax = rentSlider && rentSlider.dataset ? parseInt(rentSlider.dataset.rentMax) : 0
            }   
            scope.rentSlider = {
                start: [scope.rentMin, scope.rentMax],
                step: 100,
                range: {
                    min: scope.rentMin,
                    max: scope.rentMax
                },
                connect: true,
                margin: 100,
            }
            let timer;
            scope.$watch('sqftSlider.start', (val) => {
                $timeout.cancel(timer);
                timer = $timeout(function() {
                    scope.filterFloorplans()
                }, 500);
            }, true)
            scope.$watch('rentSlider.start', (val) => {
                $timeout.cancel(timer);
                timer = $timeout(function() {
                    scope.filterFloorplans()
                }, 500);
            }, true)

            scope.filterFloorplans = function() {
                const floorplans = Array.prototype.slice.call(document.querySelectorAll(".cp-Floorplan"));
                scope.filtered = floorplans.filter(function(fp) {
                    let filterResults = []
                    // loop over filter functions and test that each returns true. If false, test fails and fp is excluded from results
                    for (let filter in scope.FilterFns) {
                        let filterFn = scope.FilterFns[filter];
                        // console.log('filter',filter, filterFn(fp));
                        filterResults.push(filterFn(fp))
                    }
                    return filterResults.every(result => result);
                    // return true;
                });
                // console.log('filtered ' , scope.filtered);
            }
            scope.filterFloorplans();

            scope.getTimes = function(pikaday) {
                scope.dayOfWeek = pikaday.getDate().getDay();
                const selectedDay = scope.appointment_days.filter(function(day) {
                    return day.day == scope.dayOfWeek;
                });
                if (selectedDay.length && selectedDay[0].times) {
                    scope.times = selectedDay[0].times;
                    scope.appointmentInputs.time = scope.times[0];
                } else {
                    scope.times = [{time: "No appointments available"}];
                    scope.appointmentInputs.time = scope.times[0];
                }
                // console.log('scope.times', scope.times);
            }

            scope.showUnits = null;
            scope.toggleUnits = function(id) {
                scope.showUnits = id;
                $timeout(function() {
                    id && scrollTo(document.querySelector('#floorplan-'+id+' .floorplan-details').offsetTop)
                },100)
            };

            Math.easeInOutQuad = function (t, b, c, d) {
              t /= d/2;
              if (t < 1) {
                return c/2*t*t + b
              }
              t--;
              return -c/2 * (t*(t-2) - 1) + b;
            };

            // requestAnimationFrame for Smart Animating http://goo.gl/sx5sts
            var requestAnimFrame = (function(){
              return  window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || function( callback ){ window.setTimeout(callback, 1000 / 60); };
            })();

            function scrollTo(to, callback, duration) {
                var offset = 80
              function move(amount) {
                document.documentElement.scrollTop = amount;
                document.body.parentNode.scrollTop = amount;
                document.body.scrollTop = amount;
              }
              function position() {
                return document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
              }
              var start = position(),
                change = (to - offset) - start,
                currentTime = 0,
                increment = 20;
              duration = (typeof(duration) === 'undefined') ? 500 : duration;
              var animateScroll = function() {
                // increment the time
                currentTime += increment;
                // find the value with the quadratic in-out easing function
                var val = Math.easeInOutQuad(currentTime, start, change, duration);
                // move the document.body
                move(val);
                // do the animation unless its over
                if (currentTime < duration) {
                  requestAnimFrame(animateScroll);
                } else {
                  if (callback && typeof(callback) === 'function') {
                    // the animation is done so lets callback
                    callback();
                  }
                }
              };
              animateScroll();
            }
        }
    }

}];

export const floorplan = [ '$http', function($http){
    return {
        scope: true,
        link: function(scope, elem, attrs) {

            scope.swapImage = function(url) {
                scope.mainFloorplanImage = url;
            };
        }
    }
}];

export const galleryFilter = [ function() {
    return {
        link: function(scope, elem, attrs) {

            let grid = document.querySelector('.gallery-wrap');
                
            let iso = new Isotope( grid, {
                itemSelector: '.gallery-image',
                layoutMode: 'fitRows',
            });

            scope.changeFilter = function(filter) {
                scope.filter = filter;
                console.log(scope.filter);
                iso.arrange({
                    filter: scope.filter
                });
            };
        }
    }
}];
